import PropTypes from "prop-types";

export default PropTypes.shape({
  agencyBriefing: PropTypes.string,
});
